import type { Msg } from '@halo/chat-sdk-react';
import { isEmojiOnlyMessage } from '@halo/chat-sdk-react';
import { MsgBubble } from '../../msg-parts';

export interface MsgTextBubbleProps {
  message: Msg;
  children: ReactNode;
}

export const MsgTextBubble = memo(function MsgTextBubble({
  message,
  children,
}: MsgTextBubbleProps) {
  const isEmojiOnly = useMemo(() => isEmojiOnlyMessage(message), [message]);

  const bubbleProps = useMemo(() => {
    if (isEmojiOnly) {
      return {
        p: '0',
        bg: 'transparent',
        borderRadius: 'none',
      };
    }
  }, [isEmojiOnly]);

  return (
    <MsgBubble message={message} userSelect="var(--session-user-select)" {...bubbleProps}>
      {children}
    </MsgBubble>
  );
});
